import config from '../config';

const BEACON_URL = 'https://static.cloudflareinsights.com/beacon.min.js';
const BEACON_ATTRIBUTE = 'data-cf-beacon';

/**
 * Add the Cloudflare Web Analytics beacon to the page
 *
 * This is done here rather than in public/index.html because the token lives
 * in config.ts, which the HTML template can't read.
 *
 * Pre-rendered pages are captured after this has run, so their HTML already
 * has the tag by the time the app boots in a visitor's browser - hence the
 * check for an existing one. The beacon follows client-side navigation by
 * itself, so one tag per page load is all it needs.
 */
export function loadWebAnalytics(): void {
  const token = config.cloudflare.webAnalyticsToken;

  if (config.env !== 'production' || !token) {
    return;
  }

  if (document.querySelector(`script[${BEACON_ATTRIBUTE}]`)) {
    return;
  }

  const script = document.createElement('script');
  script.defer = true;
  script.src = BEACON_URL;
  script.setAttribute(BEACON_ATTRIBUTE, JSON.stringify({ token }));
  document.head.appendChild(script);
}
